import React, { useEffect, useState } from 'react'

const MultiSelectDropDown = (props) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const { maneuverType, maneuverTypeArray , maneuverCallback , isdropDownOpen , setIsDropDownOpen} = props

     
    useEffect(() => {
    maneuverCallback(selectedItems);
    } , [selectedItems])
    


    const toggleDropdown = () => {
        setIsDropDownOpen(!isdropDownOpen)
    };

    // console.log("Selected Items " , selectedItems);

    const handleChange = e => {
        const { value, checked } = e.target;

        // Update state based on checkbox checked status
        if (checked) {
            setSelectedItems(prevSelectedItems => [...prevSelectedItems, value]);
        } else {
            setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
        }
      };

    return (
        <div>
            <>

                <button
                    id="dropdownCheckboxButton"
                    data-dropdown-toggle="dropdownDefaultCheckbox"
                    className="text-gray-800 bg-white  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    type="button"
                    onClick={toggleDropdown}
                >
                    {maneuverType}
                    <svg
                        className="w-3 h-2 ml-2 text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 10 6"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="m1 1 4 4 4-4"
                        />
                    </svg>
                </button>
                {/* Dropdown menu */}
                <div
                    id="dropdownDefaultCheckbox"
                    className={`absolute top-10 mt-2 z-10 ${isdropDownOpen ? '' : 'hidden'} w-48 bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600`}
                >
                    <ul
                        className="p-3 space-y-3 text-sm text-gray-700 dark:text-gray-200"
                        aria-labelledby="dropdownCheckboxButton"
                    >
                        {maneuverTypeArray?.map((item) => 
                         (
                            <li>
                                <div className="flex items-center">
                                    <input
                                        id="checkbox-item-1"
                                        type="checkbox"
                                        defaultValue=""
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                        onChange={handleChange}
                                        value={item}
                                    />
                                    <label
                                        htmlFor="checkbox-item-1"
                                        className="ms-2 px-2 text-sm font-normal text-gray-700 dark:text-gray-300"
                                    >
                                        {item}
                                    </label>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </>

        </div>
    )
}

export default MultiSelectDropDown